// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__b_0YI","th":"Table_th__0qGP3","td":"Table_td__6I_Mv","tdDescription":"Table_tdDescription__urzZZ","tr":"Table_tr__o3cDC","svg":"Table_svg__ZPGRN"};